module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"startTypingAddress":"Начните вводить адрес"}}')
  delete Component.options._Ctor
}
